import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ResponsivenessMixin extends Vue {
  get isDesktop(): boolean {
    return !this.isTablet && !this.isMobile;
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get isXSScreen(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get isOnlyTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown && !this.$vuetify.breakpoint.mdAndDown;
  }

  get screenWidth(): number {
    return this.$vuetify.breakpoint.width;
  }
}
